import React from 'react';
import { NavigationRoute, useNavigation, useRouterPath } from 'shared-utils';
import Breadcrumb from 'components/Breadcrumb';
import { DashboardNavigation, UserNavigation } from 'screens/routes';

type Props = {
    label: string;
};

const UserDetailsBreadcrumb: React.FC<Props> = ({ label }: Props) => {
    const homePath = useRouterPath(DashboardNavigation());
    const userPath = useRouterPath(UserNavigation());
    const { push: navigate } = useNavigation();

    const triggerNav = React.useCallback((route: NavigationRoute) => (event: React.MouseEvent<any>) => {
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();
        navigate(route);
    }, [navigate]);

    return (
        <Breadcrumb>
            <Breadcrumb.Home
                key="bc-home"
                to={homePath ?? undefined}
                onClick={triggerNav(DashboardNavigation())}
            />
            <Breadcrumb.Item
                key="bc-user"
                to={userPath ?? undefined}
                onClick={triggerNav(UserNavigation())}
            >
                Utilisateurs
            </Breadcrumb.Item>
            <Breadcrumb.Item key="bc-user-details">{label}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default UserDetailsBreadcrumb;
